import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_CONVERT: MijnRoute = {
    path: 'hypotheken-aflossingsvrij-omzetten',
    navigationEvent: 'toHypothekenAflossingsvrijOmzetten',
    regex: /^\/hypotheek\/hypotheken-aflossingsvrij-omzetten$/,
    webcomponent: 'mijn-hypotheken-aflossingsvrij-omzetten-webcomponent'
};
